import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["classes", "contained", "windowHeight"];
import React from 'react';
import { CircularProgress, createStyles, withStyles } from '@material-ui/core';
import { WindowHeightProvider } from '../HeightUtils';
const zIndex = 10000;
const progressSizePx = 72;
const styles = createStyles(() => ({
  fixedLoaderRoot: {
    position: 'fixed',
    display: 'flex',
    margin: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '100%',
    padding: 0,
    zIndex
  },
  containedLoaderRoot: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex
  },
  progressRoot: {
    color: '#75c4e8',
    width: `${progressSizePx}px !important`,
    height: `${progressSizePx}px !important`
  }
}));

const ProgressBody = _ref => {
  let {
    classes,
    contained,
    windowHeight: _windowHeight
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    id: "overlay-loader"
  }, props, {
    className: contained ? classes.containedLoaderRoot : classes.fixedLoaderRoot
  }), /*#__PURE__*/React.createElement(CircularProgress, {
    disableShrink: true,
    thickness: 3,
    classes: {
      root: classes.progressRoot
    }
  }));
};

const StyledOverlayLoader = withStyles(styles)( /*#__PURE__*/React.memo(ProgressBody));
/** Centered spinner between default Loader and BigLoader (no backdrop). */

export const OverlayLoader = props => /*#__PURE__*/React.createElement(WindowHeightProvider, null, windowHeight => /*#__PURE__*/React.createElement(StyledOverlayLoader, _extends({}, props, {
  windowHeight: windowHeight.clientHeight
})));
export default OverlayLoader;